import { render, staticRenderFns } from "./AscAirlineMgmtWrapper.vue?vue&type=template&id=7de61fe8&"
import script from "./AscAirlineMgmtWrapper.vue?vue&type=script&lang=js&"
export * from "./AscAirlineMgmtWrapper.vue?vue&type=script&lang=js&"
import style0 from "./AscAirlineMgmtWrapper.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports